module.exports = __webpack_public_path__ + "media/images/icons/outlined/swap-left-fc66e7ef4ce3a62c7008b247268496e2.svg";